import { JsonObject, JsonProperty } from 'json2typescript';
import { BaseObject } from './base-object-model';

@JsonObject('Brand')
export class Brand extends BaseObject {
  @JsonProperty('id', Number, false) id: number = undefined;
  @JsonProperty('name', String, false) name: string = undefined;
}
